export default "__VITE_ASSET__BpcYqfqR__"